const DEFAULT_API_URL = 'http://localhost:8000/api';

const readBooleanConfig = (value) => {
  if (typeof value === 'boolean') {
    return value;
  }

  return ['1', 'true', 'yes', 'on'].includes(String(value || '').trim().toLowerCase());
};

export const API_URL =
  window.__APP_CONFIG__?.API_URL ||
  process.env.REACT_APP_API_URL ||
  DEFAULT_API_URL;

export const API_BASE_URL = API_URL.replace(/\/api$/, '');

export const PUBLIC_ACCOUNT_SIGNUP_ENABLED = readBooleanConfig(
  window.__APP_CONFIG__?.PUBLIC_ACCOUNT_SIGNUP_ENABLED ??
  process.env.REACT_APP_PUBLIC_ACCOUNT_SIGNUP_ENABLED,
);
